import { Toaster as Sonner, type ToasterProps } from 'sonner'
import { useUploads } from '@/features/media/upload/store'
import { useResolvedTheme } from '@/hooks/use-theme'

export function Toaster(props: ToasterProps) {
  const theme = useResolvedTheme()
  // Stack toasts above the upload tray (both live bottom-right).
  const trayHeight = useUploads((s) => s.trayHeight)
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      closeButton
      offset={trayHeight ? { bottom: trayHeight + 28, right: 16 } : undefined}
      toastOptions={{
        classNames: {
          toast: '!rounded-xl !border-border !bg-popover !text-popover-foreground !shadow-lg',
          description: '!text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}
